import React, {useEffect, useState} from "react";
import {Table} from "antd";
import {LinkSimple} from "@phosphor-icons/react";
import {lossesColumns, vendorLossesValues, VendorKey} from "../../../../Constants";
import oneDRAWpdf from "../../../../assets/PDF/oneDRAW Production and Losses Logic.pdf";
import IGSpdf from "../../../../assets/PDF/IGS - System Loss Inputs.pdf"
import GoodLeapPdf from "../../../../assets/PDF/GoodLeap - Design Installation and Commissioning Standards_FINAL.pdf"

interface LossesInfoDetailProps {
    vendor: VendorKey;
}

const LossesInfoDetail: React.FC<LossesInfoDetailProps> = ({vendor}) => {
    const [lossData, setLossData] = useState<typeof vendorLossesValues[VendorKey]>([]);
    const lossValues = vendorLossesValues

    useEffect(() => {
        setLossData(lossValues[vendor])
    }, [vendor]);

    const vendorDocumentationLink = {
        oneDRAW: oneDRAWpdf,
        IGS: IGSpdf,
        GoodLeap: GoodLeapPdf,
        LightReach: "https://help.palmetto.finance/en/articles/8305985-design-package-inputs-and-deliverables",
        LightYear: null, //Leaving two as null until we get documentation for them
        Sunlight: null
    }

    return (
        <>
            <p className={"theme-based-text-color"} style={{textAlign: 'center'}}>
                You are viewing losses for {vendor}.
            </p>
            <br/>
            <Table
                dataSource={lossData}
                columns={lossesColumns}
                pagination={false}
                style={{width: '100%', marginTop: '5px'}}
                bordered={true}
                rowClassName={() => "compact-row"}
                className="losses-table"
            />
            <br/>
            {vendorDocumentationLink[vendor] &&
                <>
                    <p className={"theme-based-text-color"}>
                        Below is a detailed breakdown of calculated losses for {vendor}:
                    </p>
                    <br/>
                
                    <p>Documentation Link : <a href={vendorDocumentationLink[vendor]} target="_blank"><LinkSimple/>Click to Open</a>
                    </p>
                </>
            }
        </>
    )
}

export default LossesInfoDetail;